export var Platform;
(function (Platform) {
    Platform["FACEBOOK"] = "FACEBOOK";
    Platform["TELEGRAM"] = "TELEGRAM";
    Platform["APPLE"] = "APPLE";
    Platform["GOOGLE"] = "GOOGLE";
})(Platform || (Platform = {}));
export var UserRole;
(function (UserRole) {
    UserRole["REGULAR"] = "REGULAR";
    UserRole["AUTHOR"] = "AUTHOR";
    UserRole["DEVELOPER"] = "DEVELOPER";
})(UserRole || (UserRole = {}));
export var Theme;
(function (Theme) {
    Theme["LIGHT"] = "LIGHT";
    Theme["DARK"] = "DARK";
    Theme["SYSTEM"] = "SYSTEM";
})(Theme || (Theme = {}));
export var CollectionType;
(function (CollectionType) {
    CollectionType["EMERGENCY"] = "EMERGENCY";
    CollectionType["REGULAR"] = "REGULAR";
})(CollectionType || (CollectionType = {}));
export var CollectionStatus;
(function (CollectionStatus) {
    CollectionStatus["ACTIVE"] = "ACTIVE";
    CollectionStatus["BLOCKED"] = "BLOCKED";
    CollectionStatus["CLOSED"] = "CLOSED";
    CollectionStatus["CANCELLED"] = "CANCELLED";
})(CollectionStatus || (CollectionStatus = {}));
export var NotificationType;
(function (NotificationType) {
    NotificationType["NEW_COLLECTION"] = "NEW_COLLECTION";
    NotificationType["COLLECTION_BLOCKED"] = "COLLECTION_BLOCKED";
    NotificationType["COLLECTION_CLOSED"] = "COLLECTION_CLOSED";
    NotificationType["NEW_OBLIGATION"] = "NEW_OBLIGATION";
    NotificationType["RE_NOTIFY"] = "RE_NOTIFY";
    NotificationType["SPECIAL_AUTHOR"] = "SPECIAL_AUTHOR";
    NotificationType["SPECIAL_DEVELOPER"] = "SPECIAL_DEVELOPER";
    NotificationType["INVITE_ACCEPTED"] = "INVITE_ACCEPTED";
})(NotificationType || (NotificationType = {}));
export var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["UNREAD"] = "UNREAD";
    NotificationStatus["READ"] = "READ";
    NotificationStatus["DISMISSED"] = "DISMISSED";
    NotificationStatus["RESPONDED"] = "RESPONDED";
    NotificationStatus["EXPIRED"] = "EXPIRED";
})(NotificationStatus || (NotificationStatus = {}));
//# sourceMappingURL=types.js.map